// ** React Imports
import { Navigate, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Suspense } from 'react';

// auth config import
import authConfig from '@src/auth/config.js';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ children, route }) => {
    // ** Hooks & Vars
    const user = JSON.parse(localStorage.getItem(authConfig.storageTokenKeyName));
    const permissionSlice = useSelector((state) => state?.permission);
    const location = useLocation();
    const navigate = useNavigate();

    const { search } = useLocation();
    const urlQuery = new URLSearchParams(search);
    const stateParam = urlQuery.get('query');

    const canView = (id) => {
        if (id) {
            return permissionSlice?.permission?.includes(String(id));
        }
    };

    if (route) {
        let action = null;
        let resource = null;
        let restrictedRoute = false;

        if (route.meta) {
            action = route.meta.action;
            resource = route.meta.resource;
            restrictedRoute = route.meta.restricted;
        }

        if (!user) {
            return (
                <Navigate
                    to={{
                        pathname: '/login',
                        search: `?query=${location.pathname}`
                    }}
                    replace
                />
            );
        }
        if (user && restrictedRoute) {
            return <Navigate to="/" />;
        }
        if (user && stateParam) {
            return navigate(stateParam);
        }

        if (route?.dbId) {
            if (!canView(route?.dbId)) {
                return <Navigate to="/" />;
            }
        }
    }

    return <Suspense fallback={null}>{children}</Suspense>;
};

export default PrivateRoute;
